export const pdf = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <g>
      <path
        d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
        fill="#e2e5e7"
        data-original="#e2e5e7"
      ></path>
      <path
        d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
        fill="#b0b7bd"
        data-original="#b0b7bd"
      ></path>
      <polygon
        points="480,224 384,128 480,128 "
        fill="#cad1d8"
        data-original="#cad1d8"
      ></polygon>
      <path
        d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16  V416z"
        fill="#f15642"
        data-original="#f15642"
      ></path>
      <g>
        <path
          d="M101.744,303.152c0-4.224,3.328-8.832,8.688-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48   c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.688-3.184-8.688-8.816V303.152z    M118.624,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H118.624z"
          fill="#ffffff"
          data-original="#ffffff"
        ></path>
        <path
          d="M196.656,384c-4.224,0-8.832-2.304-8.832-7.92v-72.672c0-4.592,4.608-7.936,8.832-7.936h29.296   c58.464,0,57.184,88.528,1.152,88.528H196.656z M204.72,311.088V368.4h21.232c34.544,0,36.08-57.312,0-57.312H204.72z"
          fill="#ffffff"
          data-original="#ffffff"
        ></path>
        <path
          d="M303.872,312.112v20.336h32.624c4.608,0,9.216,4.608,9.216,9.072c0,4.224-4.608,7.68-9.216,7.68   h-32.624v26.864c0,4.48-3.184,7.92-7.664,7.92c-5.632,0-9.072-3.44-9.072-7.92v-72.672c0-4.592,3.456-7.936,9.072-7.936h44.912   c5.632,0,8.96,3.344,8.96,7.936c0,4.096-3.328,8.704-8.96,8.704h-37.248V312.112z"
          fill="#ffffff"
          data-original="#ffffff"
        ></path>
      </g>
      <path
        d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
        fill="#cad1d8"
        data-original="#cad1d8"
      ></path>
    </g>
  </svg>
);
export const iManageIcon = (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="300.000000pt" height="260.000000pt" viewBox="0 0 300.000000 260.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,260.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M1415 2314 c-142 -21 -213 -37 -281 -64 -306 -122 -556 -395 -689
-755 -74 -199 -92 -365 -55 -509 27 -106 63 -169 143 -248 263 -262 861 -312
1442 -122 442 145 760 394 876 685 29 75 22 157 -22 247 -18 37 -35 69 -39 72
-3 3 -16 19 -28 36 -32 47 -139 155 -205 208 -235 188 -587 369 -832 426 -80
19 -253 32 -310 24z m-344 -467 c21 -14 39 -38 48 -63 12 -36 12 -44 -4 -77
-21 -44 -59 -67 -111 -67 -54 0 -104 53 -104 110 0 52 13 76 53 100 42 26 76
25 118 -3z m369 -208 c28 -6 73 -26 101 -45 l50 -33 50 34 c154 105 362 43
442 -134 20 -42 21 -64 22 -261 l0 -215 -80 0 -80 0 -5 213 -5 214 -37 34
c-32 29 -45 34 -86 34 -62 0 -112 -32 -129 -80 -7 -22 -12 -106 -12 -227 l-1
-193 -80 0 -80 0 0 195 c0 220 -7 251 -62 285 -45 27 -117 27 -152 -1 -48 -37
-51 -52 -56 -269 l-5 -205 -77 -3 -78 -3 0 214 c0 166 3 224 15 258 30 84 98
149 188 180 61 21 88 23 157 8z"/>
    </g>
  </svg>
)
export const iManageColorIcon = (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    viewBox="0 0 300 300" enable-background="new 0 0 300 300"
    width="500.000000pt" height="500.000000pt">
    <path fill="#F9FAFA" opacity="1.000000" stroke="none"
      d="
M164.000000,301.000000 
	C110.666679,301.000000 57.833241,300.957855 5.000285,301.097351 
	C1.575169,301.106415 0.900214,300.424103 0.904390,296.999908 
	C1.023108,199.666748 1.023101,102.333366 0.904406,5.000198 
	C0.900231,1.576255 1.575740,0.900207 5.000033,0.904384 
	C102.333206,1.023108 199.666595,1.023098 296.999756,0.904413 
	C300.423584,0.900238 301.099823,1.575593 301.095642,4.999979 
	C300.976929,102.333153 300.976898,199.666534 301.095581,296.999695 
	C301.099731,300.423431 300.425934,301.109589 296.999847,301.098083 
	C252.833618,300.949829 208.666733,301.000000 164.000000,301.000000 
z"/>
    <path fill="#1405E7" opacity="1.000000" stroke="none"
      d="
M251.647034,162.091675 
	C251.492142,162.995789 251.379074,163.529312 251.216965,164.331345 
	C248.868347,170.244781 243.990723,173.732300 239.675308,177.463593 
	C222.587051,192.238937 202.441101,201.143921 180.915054,207.384735 
	C165.754501,211.780106 150.214554,213.838181 134.590851,214.046326 
	C118.059418,214.266586 101.576492,212.289459 86.486313,204.661301 
	C64.245850,193.418686 55.171497,174.477844 60.214935,148.890961 
	C64.432167,127.495651 74.192574,108.850647 89.420975,92.980453 
	C98.968292,83.030754 109.987007,75.632370 122.645233,70.441055 
	C124.858841,69.533218 127.046677,68.973099 129.817474,69.422455 
	C131.223465,69.299171 132.236908,69.225677 133.631348,69.158890 
	C138.036514,68.684990 141.462799,70.806038 144.991058,72.031822 
	C177.767944,83.419243 207.526733,99.874657 231.584885,125.367386 
	C239.362473,133.608765 245.841141,142.918381 250.140244,153.540756 
	C251.190414,156.135513 252.338577,158.775452 251.647034,162.091675 
z"/>
    <path fill="#48CBFA" opacity="1.000000" stroke="none"
      d="
M129.853088,69.161331 
	C98.714813,79.104813 79.132645,101.176140 66.966141,130.760178 
	C62.311893,142.077438 59.404564,153.786102 60.516109,166.247269 
	C62.233051,185.495346 73.377205,197.481216 90.289223,204.752472 
	C110.642593,213.503296 131.973114,213.719971 153.568726,211.224457 
	C177.708099,208.434998 200.323227,201.114670 221.359070,188.963501 
	C232.410675,182.579620 241.991043,174.383820 250.825455,164.743591 
	C254.692551,169.416107 253.210297,174.846603 252.307465,179.803436 
	C249.711639,194.055527 240.966385,204.365540 229.363342,212.353851 
	C207.068909,227.702759 182.059052,235.330170 155.324799,237.979904 
	C138.146347,239.682510 121.532959,237.646576 105.412666,231.345551 
	C86.016518,223.764099 71.201241,210.790771 61.529015,192.561417 
	C48.115635,167.281036 41.941910,140.032822 42.273472,111.409431 
	C42.354286,104.432838 43.702206,97.541344 45.688515,90.808762 
	C50.754848,73.636406 63.908165,67.419159 80.112549,65.122383 
	C96.876198,62.746330 113.258202,64.798370 129.853088,69.161331 
z"/>
    <path fill="#6763F9" opacity="1.000000" stroke="none"
      d="
M251.899658,162.318451 
	C246.935959,144.407440 235.861359,130.511963 222.499329,118.228455 
	C198.922760,96.554848 171.312973,81.911125 140.996994,72.087921 
	C138.792709,71.373680 136.640167,70.499741 134.237961,69.432831 
	C137.562317,67.539429 141.316193,67.008919 145.612076,67.179520 
	C149.762817,68.577118 153.548691,68.055428 157.642822,67.492165 
	C166.480972,67.022110 174.352829,69.817680 182.133652,72.715324 
	C205.917191,81.572540 227.617905,93.917404 245.938278,111.723251 
	C250.371704,116.032150 254.266998,120.849060 257.268585,126.261246 
	C264.584656,139.452988 261.168396,151.231140 251.899658,162.318451 
z"/>
    <path fill="#5652FB" opacity="1.000000" stroke="none"
      d="
M157.510925,67.202316 
	C154.228867,70.436775 150.249390,69.248154 146.153717,67.637253 
	C149.715942,67.210701 153.391022,67.149185 157.510925,67.202316 
z"/>
    <path fill="#F2F2FD" opacity="1.000000" stroke="none"
      d="
M200.014435,172.560303 
	C186.923203,174.782486 186.922699,174.782486 186.921524,162.348129 
	C186.920990,156.693634 186.989502,151.038162 186.906693,145.384888 
	C186.804581,138.414154 182.477692,133.788437 176.042236,133.602585 
	C169.755722,133.421036 164.943619,137.995026 164.729660,144.931274 
	C164.483643,152.906570 164.491302,160.900681 164.744904,168.875305 
	C164.856628,172.388535 163.776749,173.437195 160.289444,173.407181 
	C152.053757,173.336319 152.048279,173.504807 152.041824,165.271561 
	C152.036606,158.619217 152.114166,151.965912 152.024170,145.314789 
	C151.928238,138.226120 147.689163,133.734055 141.173676,133.608109 
	C134.822327,133.485306 130.075745,138.040054 129.861435,145.025299 
	C129.621857,152.834473 129.557800,160.667480 129.902969,168.468613 
	C130.082611,172.528214 128.768982,173.862640 124.888008,173.366409 
	C122.593445,173.073029 120.251152,173.152878 117.535347,173.007767 
	C116.675774,172.468750 116.197670,171.907211 116.192261,171.261749 
	C116.109802,161.426147 115.432854,151.582352 116.839081,141.375580 
	C119.002090,136.988861 119.954910,132.639435 123.139610,129.183060 
	C131.580017,120.022598 144.434219,118.246025 154.572266,125.568634 
	C157.469986,127.661636 159.221939,127.738541 162.110336,125.547424 
	C174.396500,116.227257 195.154373,121.528793 199.440735,140.834747 
	C200.220993,141.504028 200.768295,142.026611 200.775528,142.677017 
	C200.885132,152.532486 201.642670,162.398239 200.014435,172.560303 
z"/>
    <path fill="#F1F0FC" opacity="1.000000" stroke="none"
      d="
M117.385010,105.609085 
	C121.034904,108.951279 121.762505,112.626991 119.687767,116.653091 
	C118.016914,119.895432 115.004776,121.499908 111.481430,121.253693 
	C107.506310,120.975914 104.790596,118.572502 103.455437,114.770958 
	C102.179543,111.138153 103.607880,108.192657 106.225685,105.869057 
	C109.612999,102.862427 113.343147,102.613258 117.385010,105.609085 
z"/>
    <path fill="#0000E4" opacity="1.000000" stroke="none"
      d="
M116.741470,141.079742 
	C117.137840,151.333954 117.128273,161.677292 117.129539,172.485626 
	C115.441040,172.835312 114.996063,171.776215 115.001045,170.257446 
	C115.030762,161.192810 115.024963,152.128082 115.048386,143.063416 
	C115.050667,142.181137 115.458763,141.496124 116.741470,141.079742 
z"/>
    <path fill="#0300E5" opacity="1.000000" stroke="none"
      d="
M200.063812,172.850250 
	C199.605240,162.596069 199.569168,152.307083 199.602875,141.560486 
	C201.372116,141.092361 201.992645,142.033188 201.987823,143.625031 
	C201.960175,152.764648 201.961136,161.904327 201.925568,171.043900 
	C201.922043,171.949127 201.402573,172.579208 200.063812,172.850250 
z"/>
  </svg>
)
export const ai = (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M2410 5105 c-308 -62 -598 -318 -814 -717 l-47 -87 -172 0 c-336 -1
-614 -74 -795 -208 -17 -13 -37 -21 -42 -18 -5 3 -35 10 -66 15 -180 29 -354
-98 -383 -281 -18 -111 18 -217 100 -298 48 -47 49 -50 49 -107 0 -211 102
-510 260 -766 l49 -78 -49 -78 c-158 -256 -260 -555 -260 -767 0 -59 -1 -62
-46 -104 -27 -26 -58 -69 -76 -108 -28 -59 -30 -70 -26 -151 3 -68 10 -98 30
-137 52 -101 142 -167 253 -185 51 -8 140 0 165 15 4 2 38 -15 75 -40 126 -83
317 -148 515 -176 47 -6 160 -12 253 -13 l167 -1 53 -95 c191 -345 427 -576
683 -669 449 -164 899 79 1228 664 l56 99 167 2 c93 0 206 6 253 13 198 28
388 93 514 176 60 39 70 43 94 33 15 -6 59 -11 97 -11 94 0 176 35 243 107 69
73 95 146 90 251 -5 96 -28 147 -98 220 l-48 50 -5 95 c-14 226 -99 470 -250
718 l-56 92 56 93 c151 247 235 490 250 717 l6 95 45 45 c68 67 103 151 103
242 0 41 -6 92 -15 117 -35 96 -122 180 -221 212 -48 15 -159 16 -198 0 -24
-9 -35 -6 -102 39 -184 120 -438 181 -756 181 l-167 0 -60 107 c-297 527 -695
779 -1102 697z m256 -166 c150 -27 300 -116 439 -261 96 -98 179 -210 239
-319 20 -36 36 -68 36 -71 0 -4 -19 -9 -42 -13 -204 -31 -479 -100 -675 -170
l-103 -37 -102 37 c-197 70 -471 139 -676 170 -35 6 -42 10 -37 23 15 42 94
169 153 248 226 300 502 442 768 393z m-1199 -822 c-78 -203 -159 -492 -196
-697 l-19 -105 -64 -55 c-116 -101 -349 -334 -441 -443 l-91 -108 -34 53 c-87
134 -167 345 -196 517 -23 135 -26 126 50 140 37 7 83 20 103 31 98 50 173
156 186 264 8 62 -14 160 -47 214 -21 34 -21 35 -2 50 62 47 258 115 399 136
124 19 359 21 352 3z m2555 -7 c63 -10 158 -35 212 -54 98 -35 190 -82 184
-94 -54 -103 -62 -129 -62 -207 0 -65 4 -90 26 -136 51 -112 137 -177 261
-200 77 -14 74 -5 51 -140 -29 -170 -108 -379 -196 -517 l-34 -53 -91 108
c-91 107 -321 339 -441 443 l-63 55 -33 166 c-40 197 -82 350 -142 516 -24 67
-44 124 -44 127 0 15 265 5 372 -14z m-2261 -5 c180 -27 549 -117 549 -134 0
-3 -67 -39 -148 -78 -197 -97 -366 -194 -546 -314 -82 -55 -151 -97 -154 -95
-6 7 32 161 75 305 31 104 114 331 120 331 2 0 48 -7 104 -15z m1744 -87 c63
-168 155 -483 155 -535 0 -7 -30 9 -67 36 -168 121 -435 278 -655 384 -71 33
-128 64 -128 68 0 21 506 138 640 148 11 1 28 -31 55 -101z m-2980 -124 c68
-44 91 -155 47 -226 -91 -147 -312 -85 -312 88 0 133 152 212 265 138z m4264
-2 c66 -49 92 -143 56 -211 -48 -94 -168 -123 -254 -61 -90 63 -86 215 7 276
55 36 139 35 191 -4z m-2131 -48 c295 -122 681 -344 953 -550 l96 -73 12 -93
c43 -343 43 -793 0 -1136 l-12 -93 -96 -73 c-126 -95 -277 -196 -428 -285
-131 -77 -496 -258 -578 -287 l-50 -17 -100 42 c-320 137 -673 341 -946 547
l-96 73 -12 93 c-44 362 -44 774 0 1136 l11 92 67 52 c94 74 316 223 451 303
194 114 583 303 628 305 7 0 52 -16 100 -36z m-1442 -831 c-15 -90 -24 -467
-15 -660 4 -115 11 -225 15 -245 3 -21 2 -38 -4 -38 -28 0 -447 459 -447 490
0 31 419 490 447 490 6 0 7 -17 4 -37z m2845 -110 c80 -82 180 -192 223 -245
l78 -98 -78 -97 c-86 -108 -369 -401 -378 -392 -3 3 -1 54 4 115 10 112 14
622 6 691 -12 95 -16 173 -8 173 5 0 74 -66 153 -147z m-3314 -600 c91 -108
322 -340 441 -443 l63 -55 34 -170 c37 -184 95 -392 150 -540 19 -51 35 -96
35 -99 0 -12 -246 -6 -348 10 -150 22 -341 86 -406 136 -19 15 -19 16 2 50 33
54 55 152 47 214 -8 70 -56 163 -105 208 -54 48 -105 73 -184 87 -76 14 -73 5
-50 140 29 170 93 345 181 492 26 42 48 77 48 77 1 0 42 -48 92 -107z m3823
-78 c52 -106 104 -268 124 -384 23 -135 26 -126 -51 -140 -124 -23 -210 -88
-261 -200 -21 -45 -26 -71 -27 -136 0 -69 4 -88 30 -140 17 -33 31 -63 33 -66
6 -14 -107 -69 -209 -103 -57 -19 -152 -42 -210 -50 -103 -16 -349 -22 -349
-10 0 3 16 48 35 99 54 146 112 353 150 539 l34 171 63 55 c120 104 350 335
441 443 l91 108 34 -53 c18 -29 51 -89 72 -133z m-2825 -767 c134 -84 358
-205 483 -263 45 -21 82 -41 82 -45 0 -9 -182 -60 -335 -95 -107 -24 -316 -58
-320 -53 -8 9 -97 256 -118 328 -28 93 -77 288 -77 307 0 7 37 -14 83 -46 45
-32 136 -92 202 -133z m1900 105 c-27 -124 -83 -308 -132 -438 -25 -66 -47
-121 -48 -123 -4 -4 -203 27 -303 49 -129 27 -352 90 -352 98 0 4 62 37 138
74 75 36 198 101 272 143 138 78 414 257 426 275 15 25 15 -6 -1 -78z m-3128
-55 c78 -47 102 -158 51 -235 -60 -90 -192 -101 -264 -21 -34 37 -44 63 -44
115 0 132 142 210 257 141z m4215 22 c77 -22 128 -87 128 -165 0 -95 -71 -167
-165 -167 -115 0 -194 103 -165 213 14 50 65 104 113 118 43 12 46 12 89 1z
m-2081 -511 c185 -68 502 -148 682 -174 26 -3 47 -9 47 -12 0 -14 -76 -144
-128 -218 -71 -100 -208 -244 -288 -301 -164 -117 -342 -164 -510 -133 -238
43 -494 257 -662 552 -62 108 -61 104 -5 112 174 24 533 117 693 179 36 13 70
25 76 25 5 1 48 -13 95 -30z"/>
      <path d="M2083 3133 c-24 -22 -80 -147 -247 -550 -119 -286 -216 -530 -216
-541 0 -30 40 -71 75 -78 53 -10 77 21 146 186 l63 150 229 0 228 0 23 -52
c12 -29 42 -99 66 -156 34 -83 48 -106 72 -118 56 -29 118 8 118 70 0 38 -421
1060 -448 1088 -10 10 -31 20 -48 24 -26 5 -37 1 -61 -23z m131 -476 c40 -97
71 -179 68 -182 -7 -7 -302 -7 -302 1 0 6 139 344 147 357 3 5 7 7 9 5 2 -3
37 -84 78 -181z"/>
      <path d="M2783 3150 c-35 -14 -56 -55 -49 -94 10 -53 27 -60 145 -66 l106 -5
0 -425 0 -425 -107 -5 c-120 -6 -135 -13 -144 -71 -5 -29 -1 -41 19 -65 l25
-29 285 -3 284 -3 32 26 c40 34 43 84 6 120 -22 23 -31 25 -125 25 l-100 0 0
430 0 430 100 0 c94 0 103 2 125 25 37 36 34 86 -6 119 l-31 26 -271 -1 c-150
0 -282 -4 -294 -9z"/>
    </g>
  </svg>
)
export const formRecognizer = (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="50" height="30" viewBox="0 0 600.000000 315.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,315.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M1420 1765 l0 -1385 636 0 c350 0 634 3 632 8 -2 4 -17 35 -33 69
l-30 63 -532 0 -533 0 0 1245 0 1245 815 0 815 0 0 -190 0 -190 195 0 195 0 0
-289 c0 -326 -9 -294 83 -307 l47 -6 0 333 0 334 -226 228 -226 227 -919 0
-919 0 0 -1385z"/>
      <path d="M1920 2309 c-13 -6 -28 -15 -32 -22 -14 -22 -8 -64 10 -80 17 -16 80
-17 704 -17 651 0 686 1 701 18 18 19 22 59 9 79 -4 6 -20 17 -35 22 -37 14
-1321 14 -1357 0z"/>
      <path d="M3080 1923 c-252 -17 -760 -93 -760 -113 0 -21 73 -361 100 -467 56
-218 125 -394 259 -661 97 -193 247 -385 383 -490 245 -188 599 -240 896 -131
281 103 503 343 582 631 37 137 44 342 14 458 -100 396 -380 654 -802 739
-172 35 -455 49 -672 34z m695 -168 c282 -49 522 -241 626 -500 49 -123 62
-201 56 -350 -5 -146 -29 -237 -93 -354 -120 -219 -337 -378 -574 -421 -269
-49 -547 39 -739 233 -79 80 -112 128 -163 236 -104 218 -101 483 8 704 101
205 284 361 503 427 135 41 241 48 376 25z"/>
      <path d="M3100 1170 l0 -130 130 0 130 0 0 130 0 130 -130 0 -130 0 0 -130z" />
      <path d="M3540 1170 l0 -130 135 0 135 0 0 130 0 130 -135 0 -135 0 0 -130z" />
      <path d="M3980 1170 l0 -130 130 0 130 0 0 130 0 130 -130 0 -130 0 0 -130z" />
      <path d="M3100 680 l0 -130 130 0 130 0 0 130 0 130 -130 0 -130 0 0 -130z" />
      <path d="M3540 680 l0 -130 135 0 135 0 0 130 0 130 -135 0 -135 0 0 -130z" />
      <path d="M3980 680 l0 -130 130 0 130 0 0 130 0 130 -130 0 -130 0 0 -130z" />
      <path d="M1900 1860 c-27 -27 -26 -75 2 -94 18 -13 52 -16 161 -16 l140 0 -7
31 c-3 17 -6 47 -6 65 l0 34 -135 0 c-122 0 -137 -2 -155 -20z"/>
      <path d="M1920 1429 c-30 -12 -40 -26 -40 -60 0 -54 19 -59 224 -59 l188 0 -6
28 c-4 15 -12 44 -17 65 l-10 37 -157 -1 c-86 0 -168 -5 -182 -10z"/>
      <path d="M1915 978 c-27 -15 -35 -28 -35 -59 0 -57 12 -59 298 -59 144 0 262
4 262 9 0 5 -11 34 -25 65 l-25 56 -227 0 c-151 -1 -235 -4 -248 -12z"/>
    </g>
  </svg>
);
export const openAI = (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="50" height="30" display="inline" viewBox="0 0 924.000000 636.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,636.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M4226 5114 c-334 -66 -612 -300 -731 -617 l-22 -60 -70 -18 c-212
-53 -421 -196 -549 -375 -53 -74 -125 -225 -147 -309 -79 -295 -5 -634 187
-859 l44 -52 -19 -70 c-94 -338 12 -708 273 -949 121 -112 265 -191 436 -237
61 -16 107 -21 222 -21 80 0 165 4 190 11 l45 11 70 -68 c189 -182 409 -271
674 -271 207 0 381 52 546 163 79 53 196 167 250 242 41 58 111 191 133 254 8
24 19 32 54 41 219 55 403 169 533 329 197 244 266 540 195 841 -26 108 -113
284 -184 371 l-54 67 19 68 c128 459 -115 949 -563 1135 -129 53 -230 73 -378
73 -74 0 -155 -6 -180 -12 l-45 -11 -70 69 c-183 176 -421 271 -680 269 -60
-1 -141 -7 -179 -15z m336 -279 c85 -18 189 -61 261 -109 l57 -38 -20 -28
c-13 -18 -152 -102 -417 -250 -219 -122 -408 -232 -421 -244 l-23 -22 1 -522
c0 -287 -3 -522 -7 -522 -5 0 -75 37 -158 83 l-150 82 -3 468 c-3 527 0 554
67 692 105 218 282 358 516 410 80 18 214 18 297 0z m974 -315 c126 -33 226
-91 330 -195 78 -77 98 -104 137 -185 51 -106 77 -213 77 -317 0 -103 -4 -111
-49 -103 -21 4 -202 100 -407 217 -437 249 -425 243 -462 243 -19 0 -175 -83
-477 -256 -247 -141 -455 -258 -462 -261 -11 -4 -13 28 -11 178 l3 183 275
154 c585 327 613 341 753 363 72 11 204 1 293 -21z m-2092 -395 c14 -21 16
-78 16 -492 0 -352 3 -474 13 -492 8 -17 151 -103 464 -280 249 -140 449 -259
445 -263 -25 -25 -298 -169 -312 -165 -33 9 -785 439 -839 481 -214 162 -319
473 -251 740 51 201 210 393 393 476 53 25 52 25 71 -5z m2110 -411 c210 -119
399 -229 421 -244 64 -44 170 -162 210 -235 155 -277 115 -611 -102 -845 -57
-62 -163 -138 -229 -166 -37 -15 -38 -15 -56 8 -16 21 -18 56 -18 491 0 383
-3 473 -14 495 -11 20 -125 90 -465 281 -248 140 -448 257 -445 260 15 15 291
170 303 170 8 1 186 -96 395 -215z m-727 -210 l203 -115 0 -213 0 -212 -205
-113 -206 -113 -204 117 -205 117 2 211 3 212 200 112 c110 62 202 113 204
113 2 0 96 -52 208 -116z m578 -328 l150 -83 0 -489 c0 -485 0 -490 -23 -564
-78 -249 -253 -424 -502 -502 -62 -19 -97 -23 -205 -23 -172 0 -265 27 -413
122 l-53 33 20 29 c14 19 152 101 432 257 226 126 415 237 420 247 6 10 10
225 9 537 0 286 3 520 7 520 5 0 76 -38 158 -84z m-375 -659 l0 -182 -392
-217 c-216 -119 -412 -226 -435 -237 -136 -67 -345 -85 -497 -42 -135 37 -229
93 -332 196 -78 77 -98 104 -137 185 -51 106 -77 213 -77 317 0 103 4 111 48
103 20 -4 217 -109 436 -235 376 -214 402 -227 440 -222 30 3 163 75 486 260
245 140 448 255 453 256 4 1 7 -81 7 -182z"/>
    </g>
  </svg>
);
export const plannerMicrosoft = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="9 7 45 50">
    <path fill="#185c37" d="M21.744,57H11.256A2.256,2.256,0,0,1,9,54.744V31.25l7.91667-2.33333L24,31.25V54.744A2.256,2.256,0,0,1,21.744,57Z" />
    <path fill="#33c481" d="M38,7H51.67A2.33,2.33,0,0,1,54,9.33V36.67A2.33,2.33,0,0,1,51.67,39H38L35.33333,21.91667Z" />
    <path fill="#107c41" d="M9,9.33V32H24V48H36.67A2.33,2.33,0,0,0,39,45.67V7H11.33A2.33,2.33,0,0,0,9,9.33Z" />
    <path fill="#21a366" d="M24 7H39V24H24z" />
  </svg>
);

export const openNewWindow = (
  <svg width="50px" height="50px" style={{ marginLeft: "-3.1rem" }} viewBox="-4 0 1 30" xmlns="http://www.w3.org/2000/svg" mirror-in-rtl="true">
    <path fill="#494c4e" d="M12.1.6a.944.944 0 0 0 .2 1.04l1.352 1.353L10.28 6.37a.956.956 0 0 0 1.35 1.35l3.382-3.38 1.352 1.352a.944.944 0 0 0 1.04.2.958.958 0 0 0 .596-.875V.96a.964.964 0 0 0-.96-.96h-4.057a.958.958 0 0 0-.883.6z" />
    <path fill="#494c4e" d="M14 11v5a2.006 2.006 0 0 1-2 2H2a2.006 2.006 0 0 1-2-2V6a2.006 2.006 0 0 1 2-2h5a1 1 0 0 1 0 2H2v10h10v-5a1 1 0 0 1 2 0z" />
  </svg>
);

export const netdoc = (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="230.000000pt" height="230.000000pt" viewBox="0 0 230.000000 230.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,230.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M0 1150 l0 -1150 1150 0 1150 0 0 1150 0 1150 -1150 0 -1150 0 0
-1150z m1960 15 l0 -545 -96 0 -95 0 2 53 c3 56 -3 59 -39 15 -13 -15 -49 -40
-80 -55 -81 -40 -175 -39 -250 2 -102 55 -162 149 -183 285 -24 155 11 314 87
400 65 71 111 92 210 98 92 5 143 -12 207 -68 l37 -32 0 196 0 196 100 0 100
0 0 -545z m-1036 225 c58 -28 101 -84 115 -151 7 -29 11 -173 11 -344 l0 -295
-99 0 -100 0 -3 283 c-3 250 -5 286 -21 315 -50 91 -188 72 -245 -33 -14 -25
-17 -72 -20 -297 l-4 -268 -99 0 -99 0 0 405 0 406 93 -3 92 -3 3 -53 3 -53
50 45 c27 24 69 52 92 60 60 22 171 16 231 -14z"/>
      <path d="M1524 1251 c-80 -36 -108 -106 -102 -254 5 -129 28 -180 100 -215 63
-32 115 -24 169 25 53 48 73 116 67 233 -5 115 -34 175 -98 208 -53 27 -82 27
-136 3z"/>
    </g>
  </svg>
);
export const rightArrow = (
  <svg fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 330 330">
    <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"/>
  </svg>
)
export const xls = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <g>
      <path
        d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
        fill="#e2e5e7"
        data-original="#e2e5e7"
      ></path>
      <path
        d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
        fill="#b0b7bd"
        data-original="#b0b7bd"
      ></path>
      <polygon
        points="480,224 384,128 480,128 "
        fill="#cad1d8"
        data-original="#cad1d8"
      ></polygon>
      <path
        d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16  V416z"
        fill="#84bd5a"
        data-original="#84bd5a"
      ></path>
      <g>
        <path
          d="M144.336,326.192l22.256-27.888c6.656-8.704,19.584,2.416,12.288,10.736   c-7.664,9.088-15.728,18.944-23.408,29.04l26.096,32.496c7.04,9.6-7.024,18.8-13.936,9.328l-23.552-30.192l-23.152,30.848   c-6.528,9.328-20.992-1.152-13.696-9.856l25.712-32.624c-8.064-10.112-15.872-19.952-23.664-29.04   c-8.048-9.6,6.912-19.44,12.8-10.464L144.336,326.192z"
          fill="#ffffff"
          data-original="#ffffff"
        ></path>
        <path
          d="M197.36,303.152c0-4.224,3.584-7.808,8.064-7.808c4.096,0,7.552,3.6,7.552,7.808v64.096h34.8   c12.528,0,12.8,16.752,0,16.752H205.44c-4.48,0-8.064-3.184-8.064-7.792v-73.056H197.36z"
          fill="#ffffff"
          data-original="#ffffff"
        ></path>
        <path
          d="M272.032,314.672c2.944-24.832,40.416-29.296,58.08-15.728c8.704,7.024-0.512,18.16-8.192,12.528   c-9.472-6-30.96-8.816-33.648,4.464c-3.456,20.992,52.192,8.976,51.296,43.008c-0.896,32.496-47.968,33.248-65.632,18.672   c-4.24-3.456-4.096-9.072-1.792-12.544c3.328-3.312,7.024-4.464,11.392-0.88c10.48,7.152,37.488,12.528,39.392-5.648   C321.28,339.632,268.064,351.008,272.032,314.672z"
          fill="#ffffff"
          data-original="#ffffff"
        ></path>
      </g>
      <path
        d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
        fill="#cad1d8"
        data-original="#cad1d8"
      ></path>
    </g>
  </svg>
);

export const image = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.98744 511">
    <g>
      <path
        d="m133.320312 373.828125c-34.152343 0-64.53125-21.867187-75.5625-54.421875l-.746093-2.453125c-2.601563-8.621094-3.691407-15.871094-3.691407-23.125v-145.453125l-51.753906 172.757812c-6.65625 25.410157 8.511719 51.753907 33.960938 58.773438l329.878906 88.34375c4.117188 1.066406 8.234375 1.578125 12.289062 1.578125 21.246094 0 40.660157-14.101563 46.101563-34.882813l19.21875-61.117187zm0 0"
        fill="#eceff1"
        data-original="#eceff1"
      ></path>
      <path
        d="m511.988281 48.492188v245.335937c0 26.453125-21.546875 48-48 48h-330.667969c-2.132812 0-4.265624-.214844-6.1875-.429687-22.398437-2.769532-39.890624-21.117188-41.597656-43.730469-.214844-1.28125-.214844-2.5625-.214844-3.839844v-245.335937c0-26.453126 21.546876-48 48-48h330.667969c26.453125 0 48 21.546874 48 48zm0 0"
        fill="#eceff1"
        data-original="#eceff1"
      ></path>
      <path
        d="m234.652344 107.160156c0 23.5625-19.101563 42.667969-42.664063 42.667969-23.566406 0-42.667969-19.105469-42.667969-42.667969s19.101563-42.667968 42.667969-42.667968c23.5625 0 42.664063 19.105468 42.664063 42.667968zm0 0"
        fill="#ffc107"
        data-original="#ffc107"
      ></path>
      <path
        d="m511.988281 233.878906v59.949219c0 26.453125-21.546875 48-48 48h-330.667969c-2.132812 0-4.265624-.214844-6.1875-.429687l219.734376-219.730469c14.507812-14.507813 38.398437-14.507813 52.90625 0zm0 0"
        fill="#388e3c"
        data-original="#388e3c"
      ></path>
      <path
        d="m385.265625 341.828125h-251.945313c-2.132812 0-4.265624-.214844-6.1875-.429687-22.398437-2.769532-39.890624-21.117188-41.597656-43.730469l101.332032-101.335938c14.507812-14.503906 38.398437-14.503906 52.90625 0zm0 0"
        fill="#4caf50"
        data-original="#4caf50"
      ></path>
    </g>
  </svg>
);

export const doc = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <g>
      <path
        d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
        fill="#e2e5e7"
        data-original="#e2e5e7"
      ></path>
      <path
        d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
        fill="#b0b7bd"
        data-original="#b0b7bd"
      ></path>
      <polygon
        points="480,224 384,128 480,128 "
        fill="#cad1d8"
        data-original="#cad1d8"
      ></polygon>
      <path
        d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16  V416z"
        fill="#50bee8"
        data-original="#50bee8"
      ></path>
      <g>
        <path
          d="M92.576,384c-4.224,0-8.832-2.32-8.832-7.936v-72.656c0-4.608,4.608-7.936,8.832-7.936h29.296   c58.464,0,57.168,88.528,1.136,88.528H92.576z M100.64,311.072v57.312h21.232c34.544,0,36.064-57.312,0-57.312H100.64z"
          fill="#ffffff"
          data-original="#ffffff"
        ></path>
        <path
          d="M228,385.28c-23.664,1.024-48.24-14.72-48.24-46.064c0-31.472,24.56-46.944,48.24-46.944   c22.384,1.136,45.792,16.624,45.792,46.944C273.792,369.552,250.384,385.28,228,385.28z M226.592,308.912   c-14.336,0-29.936,10.112-29.936,30.32c0,20.096,15.616,30.336,29.936,30.336c14.72,0,30.448-10.24,30.448-30.336   C257.04,319.008,241.312,308.912,226.592,308.912z"
          fill="#ffffff"
          data-original="#ffffff"
        ></path>
        <path
          d="M288.848,339.088c0-24.688,15.488-45.92,44.912-45.92c11.136,0,19.968,3.328,29.296,11.392   c3.456,3.184,3.84,8.816,0.384,12.4c-3.456,3.056-8.704,2.688-11.776-0.384c-5.232-5.504-10.608-7.024-17.904-7.024   c-19.696,0-29.152,13.952-29.152,29.552c0,15.872,9.328,30.448,29.152,30.448c7.296,0,14.08-2.96,19.968-8.192   c3.952-3.072,9.456-1.552,11.76,1.536c2.048,2.816,3.056,7.552-1.408,12.016c-8.96,8.336-19.696,10-30.336,10   C302.8,384.912,288.848,363.776,288.848,339.088z"
          fill="#ffffff"
          data-original="#ffffff"
        ></path>
      </g>
      <path
        d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
        fill="#cad1d8"
        data-original="#cad1d8"
      ></path>
    </g>
  </svg>
);

export const file = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <g>
      <path
        d="M104,0C86.328,0,72,14.328,72,32v448c0,17.672,14.328,32,32,32h304c17.672,0,32-14.328,32-32V128  L312,0H104z"
        fill="#e2e7f0"
        data-original="#e2e7f0"
      ></path>
      <g>
        <path
          d="M344,128h96L312,0v96C312,113.672,326.328,128,344,128z"
          fill="#9dacba"
          data-original="#9dacba"
        ></path>
        <path
          d="M192,160h128c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H192c-4.416,0-8-3.584-8-8l0,0   C184,163.584,187.584,160,192,160z"
          fill="#9dacba"
          data-original="#9dacba"
        ></path>
        <path
          d="M144,328h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0   C136,331.584,139.584,328,144,328z"
          fill="#9dacba"
          data-original="#9dacba"
        ></path>
        <path
          d="M144,424h128c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0   C136,427.584,139.584,424,144,424z"
          fill="#9dacba"
          data-original="#9dacba"
        ></path>
        <path
          d="M144,376h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0   C136,379.584,139.584,376,144,376z"
          fill="#9dacba"
          data-original="#9dacba"
        ></path>
        <path
          d="M144,280h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0   C136,283.584,139.584,280,144,280z"
          fill="#9dacba"
          data-original="#9dacba"
        ></path>
        <path
          d="M144,232h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0   C136,235.584,139.584,232,144,232z"
          fill="#9dacba"
          data-original="#9dacba"
        ></path>
      </g>
      <path
        d="M344,128l75.28,75.28c3.024,3.008,4.72,7.096,4.72,11.36V480c0,8.84-7.16,16-16,16H120  c-8.84,0-16,7.16-16,16h304c17.672,0,32-14.328,32-32V128H344z"
        fill="#c9d5e3"
        data-original="#c9d5e3"
      ></path>
    </g>
  </svg>
);

export const attachment = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
    />
  </svg>
);

export const external = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
    />
  </svg>
);

export const noContent = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 405.99 417"
  >
    <path
      d="m317.11 166.29q0.405-49.665 4.04-100.29c0.04-0.67 0.09-1.33 0.14-2q1.92-26.355 4.7-52.9v-0.1a11.007 11.007 0 0 0-11-11h-295a11.022 11.022 0 0 0-11 10.95q-3.84 36.555-6.02 72.75c-0.06 0.79-0.1 1.57-0.14 2.36q-1.08 17.895-1.72 35.7c-0.03 0.7-0.06 1.4-0.07 2.1a1478.9 1478.9 0 0 0 7.95 218.2 11.02 11.02 0 0 0 11 10.94h295a11.007 11.007 0 0 0 11-11v-0.11q-2.175-19.305-3.82-38.86-0.24-2.8651-0.47-5.73-1.14-14.085-1.99-28.28-0.18-2.865-0.33-5.73-1.605-28.41-2.1-57.26c-0.04-1.91-0.07-3.81-0.1-5.73q-0.18-14.085-0.11-28.28c0-1.91 0.01-3.82 0.04-5.73z"
      fill="#f0f0f0"
    />
    <path
      d="m405.99 75a11.007 11.007 0 0 0-11-11h-295a11.022 11.022 0 0 0-11 10.95c-9.96 94.97-11.61 188.26-4.94 278.05q1.215 16.665 2.84 33.16 0.87 8.835 1.85 17.62c0.08 0.76 0.16 1.52 0.25 2.28a11.02 11.02 0 0 0 11 10.94h295a11.007 11.007 0 0 0 11-11v-0.11c-11.93-105.77-11.93-217.06 0-330.79z"
      fill="#fff"
    />
    <path
      d="m405.99 75a11.007 11.007 0 0 0-11-11h-295a11.022 11.022 0 0 0-11 10.95c-9.96 94.97-11.61 188.26-4.94 278.05q1.215 16.665 2.84 33.16 0.87 8.835 1.85 17.62c0.08 0.76 0.16 1.52 0.25 2.28a11.02 11.02 0 0 0 11 10.94h295a11.007 11.007 0 0 0 11-11v-0.11c-11.93-105.77-11.93-217.06 0-330.79zm-2 331.06a9.0075 9.0075 0 0 1-9 8.94h-295a9.0135 9.0135 0 0 1-9-9v-0.11c-0.07-0.64-0.14-1.29-0.21-1.93q-1.035-9.18-1.93-18.41-1.575-16.185-2.79-32.55c-6.67-89.74-5.03-182.97 4.93-277.9v-0.1a9.0136 9.0136 0 0 1 9-9h295a9.0031 9.0031 0 0 1 9 8.95c-11.93 113.82-11.93 225.23 0 331.11z"
      fill="#e4e4e4"
    />
    <g fill="#e6e6e6">
      <path
        d="m120.32 166.29a2.8664 2.8664 0 0 0 0 5.7327h239.73a2.8664 2.8664 0 0 0 0-5.7327z"
        data-name="Path 142"
      />
      <path
        d="m120.32 183.49a2.8664 2.8664 0 0 0 0 5.7327h162.74a2.8664 2.8664 0 0 0 0-5.7327z"
        data-name="Path 143"
      />
      <path
        d="m120.32 200.3a2.8664 2.8664 0 0 0 0 5.7327h239.73a2.8664 2.8664 0 0 0 0-5.7327z"
        data-name="Path 142"
      />
      <path
        d="m120.32 217.5a2.8664 2.8664 0 0 0 0 5.7327h162.74a2.8664 2.8664 0 0 0 0-5.7327z"
        data-name="Path 143"
      />
      <path
        d="m120.32 263.29a2.8664 2.8664 0 0 0 0 5.7327h239.73a2.8664 2.8664 0 0 0 0-5.7327z"
        data-name="Path 142"
      />
      <path
        d="m120.32 280.49a2.8664 2.8664 0 0 0 0 5.7327h162.74a2.8664 2.8664 0 0 0 0-5.7327z"
        data-name="Path 143"
      />
      <path
        d="m120.32 297.3a2.8664 2.8664 0 0 0 0 5.7327h239.73a2.8664 2.8664 0 0 0 0-5.7327z"
        data-name="Path 142"
      />
      <path
        d="m120.32 314.5a2.8664 2.8664 0 0 0 0 5.7327h162.74a2.8664 2.8664 0 0 0 0-5.7327z"
        data-name="Path 143"
      />
    </g>
    <path
      d="m167.76 130.7h-45.788a2.2394 2.2394 0 0 1-2.2369-2.2369v-7.3362a2.2394 2.2394 0 0 1 2.2369-2.2369h45.788a2.2394 2.2394 0 0 1 2.2369 2.2369v7.3362a2.2394 2.2394 0 0 1-2.2369 2.2369z"
      fill="#9eabfa"
      data-name="Path 154"
    />
    <path
      d="m98.968 0a134.27 134.27 0 0 1-97.86 121.76c-0.03 0.7-0.06 1.4-0.07 2.1a136.29 136.29 0 0 0 99.93-123.86z"
      fill="#fff"
    />
    <path
      d="m68.338 0a134.55 134.55 0 0 1-65.37 83.7c-0.06 0.79-0.1 1.57-0.14 2.36a136.62 136.62 0 0 0 67.58-86.06z"
      fill="#fff"
    />
  </svg>
);

export const expand = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
    />
  </svg>
);

export const msTeams = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    style={{ fill: "#000000" }}
  >
    <path
      fill="#5059c9"
      d="M44,22v8c0,3.314-2.686,6-6,6s-6-2.686-6-6V20h10C43.105,20,44,20.895,44,22z M38,16	c2.209,0,4-1.791,4-4c0-2.209-1.791-4-4-4s-4,1.791-4,4C34,14.209,35.791,16,38,16z"
    ></path>
    <path
      fill="#7b83eb"
      d="M35,22v11c0,5.743-4.841,10.356-10.666,9.978C19.019,42.634,15,37.983,15,32.657V20h18	C34.105,20,35,20.895,35,22z M25,17c3.314,0,6-2.686,6-6s-2.686-6-6-6s-6,2.686-6,6S21.686,17,25,17z"
    ></path>
    <circle cx="25" cy="11" r="6" fill="#7b83eb"></circle>
    <path
      d="M26,33.319V20H15v12.657c0,1.534,0.343,3.008,0.944,4.343h6.374C24.352,37,26,35.352,26,33.319z"
      opacity=".05"
    ></path>
    <path
      d="M15,20v12.657c0,1.16,0.201,2.284,0.554,3.343h6.658c1.724,0,3.121-1.397,3.121-3.121V20H15z"
      opacity=".07"
    ></path>
    <path
      d="M24.667,20H15v12.657c0,0.802,0.101,1.584,0.274,2.343h6.832c1.414,0,2.56-1.146,2.56-2.56V20z"
      opacity=".09"
    ></path>
    <linearGradient
      id="DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1"
      x1="4.648"
      x2="23.403"
      y1="14.648"
      y2="33.403"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#5961c3"></stop>
      <stop offset="1" stopColor="#3a41ac"></stop>
    </linearGradient>
    <path
      fill="url(#DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1)"
      d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"
    ></path>
    <path
      fill="#fff"
      d="M18.068,18.999H9.932v1.72h3.047v8.28h2.042v-8.28h3.047V18.999z"
    ></path>
  </svg>
);

export const template = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
    />
  </svg>
);

export const userGroup = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);

export const calendar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
  </svg>
);

export const calculator = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    />
  </svg>
);

export const clipboardList = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
    />
  </svg>
);

export const tag = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
    />
  </svg>
);

export const lockOpen = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
    />
  </svg>
);

export const lockClosed = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
    />
  </svg>
);

export const collapse = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path d="M29.707 2.293a1 1 0 0 1 0 1.414L22.414 11H27a1 1 0 1 1 0 2h-7c-.548 0-1-.448-1-1V5a1 1 0 1 1 2 0v4.586l7.293-7.293a1 1 0 0 1 1.414 0zM13 20v7a1 1 0 1 1-2 0v-4.586l-7.293 7.293a1 1 0 0 1-1.414-1.414L9.586 21H5a1 1 0 1 1 0-2h7c.551 0 1 .452 1 1z" />
    <path d="M13 5v7c0 .555-.457 1-1 1H5a1 1 0 1 1 0-2h4.586L2.293 3.707a1 1 0 0 1 1.414-1.414L11 9.586V5a1 1 0 1 1 2 0zm16.707 23.293a1 1 0 0 1-1.414 1.414L21 22.414V27a1 1 0 1 1-2 0v-7c0-.547.447-1 1-1h7a1 1 0 1 1 0 2h-4.586z" />
  </svg>
);

export const close = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const pencil = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
    />
  </svg>
);

export const documentText = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
);

export const mail = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

export const inbox = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
    />
  </svg>
);

export const copyToClipboard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
    />
  </svg>
);

export const refresh = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
    />
  </svg>
);

export const info = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const checkCircle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const error = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const warning = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    />
  </svg>
);

export const tagmyfav = (
  <img
    height="24"
    width="24"
    src="data:image/png;base64,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"
  ></img>
);

export const down = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);

export const minus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M18 12H6" />
  </svg>
);

export const plus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const clock = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const sharePoint = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <linearGradient
      id="PtC3nmzn5K~Q855MdLFzFa_bVAf0kiXtJhO_gr1"
      x1="16.145"
      x2="26.377"
      y1="6.428"
      y2="20.715"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#048489" />
      <stop offset={1} stopColor="#03676a" />
    </linearGradient>
    <path
      fill="url(#PtC3nmzn5K~Q855MdLFzFa_bVAf0kiXtJhO_gr1)"
      d="M23,4c-6.627,0-12,5.373-12,12s5.373,12,12,12s12-5.373,12-12S29.627,4,23,4z"
    />
    <linearGradient
      id="PtC3nmzn5K~Q855MdLFzFb_bVAf0kiXtJhO_gr2"
      x1="27.122"
      x2="41.023"
      y1="18.616"
      y2="35.799"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#18939a" />
      <stop offset=".41" stopColor="#168c93" />
      <stop offset={1} stopColor="#117981" />
    </linearGradient>
    <path
      fill="url(#PtC3nmzn5K~Q855MdLFzFb_bVAf0kiXtJhO_gr2)"
      d="M33.5,16C27.701,16,23,20.701,23,26.5S27.701,37,33.5,37S44,32.299,44,26.5S39.299,16,33.5,16	z"
    />
    <linearGradient
      id="PtC3nmzn5K~Q855MdLFzFc_bVAf0kiXtJhO_gr3"
      x1={16}
      x2={32}
      y1={36}
      y2={36}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#37c6d0" />
      <stop offset={1} stopColor="#37c6d0" />
    </linearGradient>
    <path
      fill="url(#PtC3nmzn5K~Q855MdLFzFc_bVAf0kiXtJhO_gr3)"
      d="M24,28c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S28.418,28,24,28z"
    />
    <path
      d="M22.319,13H11.393C11.146,13.961,11,14.962,11,16c0,6.627,5.373,12,12,12	c0.04,0,0.078-0.006,0.118-0.006c0.003,0.019,0.006,0.037,0.009,0.056C19.12,28.485,16,31.877,16,36c0,0.339,0.028,0.672,0.069,1	h6.25C24.352,37,26,35.352,26,33.319V16.681C26,14.648,24.352,13,22.319,13z"
      opacity=".05"
    />
    <path
      d="M16,36h6.213c1.724,0,3.121-1.397,3.121-3.121V16.454c0-1.724-1.397-3.121-3.121-3.121H11.308	C11.112,14.192,11,15.082,11,16c0,6.627,5.373,12,12,12c0.04,0,0.078-0.006,0.118-0.006c0.003,0.019,0.006,0.037,0.009,0.056	C19.12,28.485,16,31.877,16,36z"
      opacity=".07"
    />
    <path
      d="M22.106,13.667H11.231C11.082,14.422,11,15.201,11,16c0,6.627,5.373,12,12,12	c0.04,0,0.078-0.006,0.118-0.006c0.003,0.019,0.006,0.037,0.009,0.056c-3.677,0.4-6.6,3.291-7.057,6.95h6.037	c1.414,0,2.56-1.146,2.56-2.56V16.227C24.667,14.813,23.52,13.667,22.106,13.667z"
      opacity=".09"
    />
    <linearGradient
      id="PtC3nmzn5K~Q855MdLFzFd_bVAf0kiXtJhO_gr4"
      x1="4.586"
      x2="23.414"
      y1="14.586"
      y2="33.414"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#058f92" />
      <stop offset={1} stopColor="#027074" />
    </linearGradient>
    <path
      fill="url(#PtC3nmzn5K~Q855MdLFzFd_bVAf0kiXtJhO_gr4)"
      d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"
    />
    <path
      fill="#fff"
      d="M10.432,28.75v-2.298c0.426,0.349,2.391,1.048,2.9,1.048c0.299,0,2.138,0.088,2.138-1.041	c0-1.633-5.082-1.494-5.082-4.725c0-0.536,0.066-3.059,4.133-3.059c1.041,0,2.271,0.261,2.628,0.395v2.147	c-0.176-0.12-0.89-0.718-2.496-0.718c-1.877,0-2.04,0.883-2.04,1.041c0,1.359,4.998,1.544,4.998,4.711	c0,3.172-3.614,3.074-4.177,3.074C12.857,29.325,10.814,28.942,10.432,28.75z"
    />
  </svg>
);

export const folder = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#FFA000"
      d="M40,12H22l-4-4H8c-2.2,0-4,1.8-4,4v8h40v-4C44,13.8,42.2,12,40,12z"
    />
    <path
      fill="#FFCA28"
      d="M40,12H8c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V16C44,13.8,42.2,12,40,12z"
    />
  </svg>
);

export const cloudUpload = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
    />
  </svg>
);

export const zipFlie = (
  <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074   c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
      fill="#e9e9e0"
      data-original="#e9e9e0"
    />
    <polygon
      points="37.5 0.151 37.5 12 49.349 12"
      fill="#d9d7ca"
      data-original="#d9d7ca"
    />
    <path
      d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
      fill="#556080"
      data-original="#556080"
    />
    <g fill="#fff">
      <path
        d="m25.266 42.924v1.326l-4.799 7.205-0.273 0.219h5.072v1.326h-6.699v-1.326l4.799-7.205 0.287-0.219h-5.086v-1.326h6.699z"
        data-original="#ffffff"
      />
      <path d="M29.271,53h-1.668V42.924h1.668V53z" data-original="#ffffff" />
      <path
        d="m33.414 53h-1.641v-10.076h2.898c0.428 0 0.852 0.068 1.271 0.205s0.795 0.342 1.128 0.615 0.602 0.604 0.807 0.991 0.308 0.822 0.308 1.306c0 0.511-0.087 0.973-0.26 1.388s-0.415 0.764-0.725 1.046-0.684 0.501-1.121 0.656-0.921 0.232-1.449 0.232h-1.217v3.637zm0-8.832v3.992h1.504c0.2 0 0.398-0.034 0.595-0.103 0.196-0.068 0.376-0.18 0.54-0.335s0.296-0.371 0.396-0.649 0.15-0.622 0.15-1.032c0-0.164-0.023-0.354-0.068-0.567-0.046-0.214-0.139-0.419-0.28-0.615-0.142-0.196-0.34-0.36-0.595-0.492s-0.593-0.198-1.012-0.198h-1.23z"
        data-original="#ffffff"
      />
    </g>
    <g fill="#c8bdb8">
      <path
        d="m28.5 24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-4v5c0 2.757 2.243 5 5 5s5-2.243 5-5v-5h-4zm2 5c0 1.654-1.346 3-3 3s-3-1.346-3-3v-3h6v3z"
        data-original="#c8bdb8"
      />
      <path
        d="m26.5 30h2c0.552 0 1-0.447 1-1s-0.448-1-1-1h-2c-0.552 0-1 0.447-1 1s0.448 1 1 1z"
        data-original="#c8bdb8"
      />
    </g>
  </svg>
);

export const grid = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
    />
  </svg>
);

export const officeBuilding = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    />
  </svg>
);

export const briefCase = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

export const contact = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
    />
  </svg>
);

export const videoCall = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
    />
  </svg>
);

export const report = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
);

export const users = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
    />
  </svg>
);

export const notification = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
    />
  </svg>
);

export const plugin = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"
    />
  </svg>
);

export const help = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const cog = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);

export const phone = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
    />
  </svg>
);

export const globeAlt = (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
    />
  </svg>
);
export const waves = (
  <svg
    id="wave"
    style={{ transform: "rotate(0deg)", transition: "0.3s" }}
    viewBox="0 0 1440 490"
    version="1.1"
  >
    <defs>
      <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
        <stop stopColor="rgba(243, 106, 62, 1)" offset="0%"></stop>
        <stop stopColor="rgba(255, 179, 11, 1)" offset="100%"></stop>
      </linearGradient>
    </defs>
    <path
      style={{ transform: "translate(0, 0px)", opacity: 1 }}
      fill="url(#sw-gradient-0)"
      d="M0,392L48,351.2C96,310,192,229,288,212.3C384,196,480,245,576,236.8C672,229,768,163,864,122.5C960,82,1056,65,1152,98C1248,131,1344,212,1440,253.2C1536,294,1632,294,1728,253.2C1824,212,1920,131,2016,138.8C2112,147,2208,245,2304,261.3C2400,278,2496,212,2592,220.5C2688,229,2784,310,2880,285.8C2976,261,3072,131,3168,65.3C3264,0,3360,0,3456,8.2C3552,16,3648,33,3744,106.2C3840,180,3936,310,4032,302.2C4128,294,4224,147,4320,81.7C4416,16,4512,33,4608,32.7C4704,33,4800,16,4896,16.3C4992,16,5088,33,5184,81.7C5280,131,5376,212,5472,212.3C5568,212,5664,131,5760,130.7C5856,131,5952,212,6048,277.7C6144,343,6240,392,6336,367.5C6432,343,6528,245,6624,171.5C6720,98,6816,49,6864,24.5L6912,0L6912,490L6864,490C6816,490,6720,490,6624,490C6528,490,6432,490,6336,490C6240,490,6144,490,6048,490C5952,490,5856,490,5760,490C5664,490,5568,490,5472,490C5376,490,5280,490,5184,490C5088,490,4992,490,4896,490C4800,490,4704,490,4608,490C4512,490,4416,490,4320,490C4224,490,4128,490,4032,490C3936,490,3840,490,3744,490C3648,490,3552,490,3456,490C3360,490,3264,490,3168,490C3072,490,2976,490,2880,490C2784,490,2688,490,2592,490C2496,490,2400,490,2304,490C2208,490,2112,490,2016,490C1920,490,1824,490,1728,490C1632,490,1536,490,1440,490C1344,490,1248,490,1152,490C1056,490,960,490,864,490C768,490,672,490,576,490C480,490,384,490,288,490C192,490,96,490,48,490L0,490Z"
    ></path>
    <defs>
      <linearGradient id="sw-gradient-1" x1="0" x2="0" y1="1" y2="0">
        <stop stopColor="rgba(243, 106, 62, 1)" offset="0%"></stop>
        <stop stopColor="rgba(255, 179, 11, 1)" offset="100%"></stop>
      </linearGradient>
    </defs>
    <path
      style={{ transform: "translate(0, 50px)", opacity: 0.9 }}
      fill="url(#sw-gradient-1)"
      d="M0,245L48,269.5C96,294,192,343,288,302.2C384,261,480,131,576,98C672,65,768,131,864,155.2C960,180,1056,163,1152,187.8C1248,212,1344,278,1440,261.3C1536,245,1632,147,1728,155.2C1824,163,1920,278,2016,318.5C2112,359,2208,327,2304,334.8C2400,343,2496,392,2592,375.7C2688,359,2784,278,2880,261.3C2976,245,3072,294,3168,277.7C3264,261,3360,180,3456,196C3552,212,3648,327,3744,310.3C3840,294,3936,147,4032,114.3C4128,82,4224,163,4320,204.2C4416,245,4512,245,4608,204.2C4704,163,4800,82,4896,98C4992,114,5088,229,5184,285.8C5280,343,5376,343,5472,302.2C5568,261,5664,180,5760,138.8C5856,98,5952,98,6048,122.5C6144,147,6240,196,6336,204.2C6432,212,6528,180,6624,196C6720,212,6816,278,6864,310.3L6912,343L6912,490L6864,490C6816,490,6720,490,6624,490C6528,490,6432,490,6336,490C6240,490,6144,490,6048,490C5952,490,5856,490,5760,490C5664,490,5568,490,5472,490C5376,490,5280,490,5184,490C5088,490,4992,490,4896,490C4800,490,4704,490,4608,490C4512,490,4416,490,4320,490C4224,490,4128,490,4032,490C3936,490,3840,490,3744,490C3648,490,3552,490,3456,490C3360,490,3264,490,3168,490C3072,490,2976,490,2880,490C2784,490,2688,490,2592,490C2496,490,2400,490,2304,490C2208,490,2112,490,2016,490C1920,490,1824,490,1728,490C1632,490,1536,490,1440,490C1344,490,1248,490,1152,490C1056,490,960,490,864,490C768,490,672,490,576,490C480,490,384,490,288,490C192,490,96,490,48,490L0,490Z"
    ></path>
    <defs>
      <linearGradient id="sw-gradient-2" x1="0" x2="0" y1="1" y2="0">
        <stop stopColor="rgba(243, 106, 62, 1)" offset="0%"></stop>
        <stop stopColor="rgba(255, 179, 11, 1)" offset="100%"></stop>
      </linearGradient>
    </defs>
    <path
      style={{ transform: "translate(0, 100px)", opacity: 0.8 }}
      fill="url(#sw-gradient-2)"
      d="M0,245L48,269.5C96,294,192,343,288,359.3C384,376,480,359,576,326.7C672,294,768,245,864,245C960,245,1056,294,1152,326.7C1248,359,1344,376,1440,359.3C1536,343,1632,294,1728,294C1824,294,1920,343,2016,367.5C2112,392,2208,392,2304,359.3C2400,327,2496,261,2592,261.3C2688,261,2784,327,2880,343C2976,359,3072,327,3168,261.3C3264,196,3360,98,3456,114.3C3552,131,3648,261,3744,302.2C3840,343,3936,294,4032,302.2C4128,310,4224,376,4320,400.2C4416,425,4512,408,4608,359.3C4704,310,4800,229,4896,171.5C4992,114,5088,82,5184,98C5280,114,5376,180,5472,212.3C5568,245,5664,245,5760,269.5C5856,294,5952,343,6048,343C6144,343,6240,294,6336,285.8C6432,278,6528,310,6624,285.8C6720,261,6816,180,6864,138.8L6912,98L6912,490L6864,490C6816,490,6720,490,6624,490C6528,490,6432,490,6336,490C6240,490,6144,490,6048,490C5952,490,5856,490,5760,490C5664,490,5568,490,5472,490C5376,490,5280,490,5184,490C5088,490,4992,490,4896,490C4800,490,4704,490,4608,490C4512,490,4416,490,4320,490C4224,490,4128,490,4032,490C3936,490,3840,490,3744,490C3648,490,3552,490,3456,490C3360,490,3264,490,3168,490C3072,490,2976,490,2880,490C2784,490,2688,490,2592,490C2496,490,2400,490,2304,490C2208,490,2112,490,2016,490C1920,490,1824,490,1728,490C1632,490,1536,490,1440,490C1344,490,1248,490,1152,490C1056,490,960,490,864,490C768,490,672,490,576,490C480,490,384,490,288,490C192,490,96,490,48,490L0,490Z"
    ></path>
    <defs>
      <linearGradient id="sw-gradient-3" x1="0" x2="0" y1="1" y2="0">
        <stop stopColor="rgba(243, 106, 62, 1)" offset="0%"></stop>
        <stop stopColor="rgba(255, 179, 11, 1)" offset="100%"></stop>
      </linearGradient>
    </defs>
    <path
      style={{ transform: "translate(0, 150px)", opacity: 0.7 }}
      fill="url(#sw-gradient-3)"
      d="M0,441L48,392C96,343,192,245,288,245C384,245,480,343,576,343C672,343,768,245,864,171.5C960,98,1056,49,1152,49C1248,49,1344,98,1440,130.7C1536,163,1632,180,1728,212.3C1824,245,1920,294,2016,294C2112,294,2208,245,2304,204.2C2400,163,2496,131,2592,171.5C2688,212,2784,327,2880,383.8C2976,441,3072,441,3168,375.7C3264,310,3360,180,3456,179.7C3552,180,3648,310,3744,359.3C3840,408,3936,376,4032,343C4128,310,4224,278,4320,228.7C4416,180,4512,114,4608,138.8C4704,163,4800,278,4896,285.8C4992,294,5088,196,5184,179.7C5280,163,5376,229,5472,228.7C5568,229,5664,163,5760,187.8C5856,212,5952,327,6048,367.5C6144,408,6240,376,6336,359.3C6432,343,6528,343,6624,285.8C6720,229,6816,114,6864,57.2L6912,0L6912,490L6864,490C6816,490,6720,490,6624,490C6528,490,6432,490,6336,490C6240,490,6144,490,6048,490C5952,490,5856,490,5760,490C5664,490,5568,490,5472,490C5376,490,5280,490,5184,490C5088,490,4992,490,4896,490C4800,490,4704,490,4608,490C4512,490,4416,490,4320,490C4224,490,4128,490,4032,490C3936,490,3840,490,3744,490C3648,490,3552,490,3456,490C3360,490,3264,490,3168,490C3072,490,2976,490,2880,490C2784,490,2688,490,2592,490C2496,490,2400,490,2304,490C2208,490,2112,490,2016,490C1920,490,1824,490,1728,490C1632,490,1536,490,1440,490C1344,490,1248,490,1152,490C1056,490,960,490,864,490C768,490,672,490,576,490C480,490,384,490,288,490C192,490,96,490,48,490L0,490Z"
    ></path>
  </svg>
);

export const filter = (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
    />
  </svg>
);
